import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
  selector: "app-duplicate-msd-dialog",
  templateUrl: "./duplicate-msd-dialog.component.html",
  styleUrls: ["./duplicate-msd-dialog.component.scss"]
})
export class DuplicateMsdDialogComponent {
  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<DuplicateMsdDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private id: string
  ) {}

  async goTo(): Promise<void> {
    this.dialogRef.close(true);

    await this.router.navigateByUrl(
      `/customer-form/success/${this.id}?partnerCode=kopetro`
    );
  }
}
